(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["azz-header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const rootSelector = '.azz-header';
    const squeezeQuery = window.matchMedia('(min-width: 990px)');

    const getScrollContainer = () => {
      if (squeezeQuery.matches) {
        return document.querySelector('.page-wrapper') ?? document.scrollingElement ?? document.documentElement;
      }
      return document.scrollingElement ?? document.documentElement;
    };

    const getScrollTop = () => getScrollContainer().scrollTop;

    const getScrollEventTarget = () => {
      if (squeezeQuery.matches) {
        return document.querySelector('.page-wrapper') ?? document;
      }
      return document;
    };

    const getIntersectionRoot = () => {
      if (squeezeQuery.matches) {
        return document.querySelector('.page-wrapper') ?? null;
      }
      return null;
    };

    const closeAllDetails = (except) => {
      document.querySelectorAll(`${rootSelector} .azz-header__details[open]`).forEach((details) => {
        if (details !== except) details.open = false;
      });
    };

    document.addEventListener(
      'toggle',
      (event) => {
        const details = event.target;
        if (!(details instanceof HTMLDetailsElement)) return;
        if (!details.matches(`${rootSelector} .azz-header__details`)) return;
        if (details.open) closeAllDetails(details);
      },
      true
    );

    document.addEventListener('click', (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;
      if (target.closest(`${rootSelector} .azz-header__details`)) return;
      closeAllDetails();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeAllDetails();
    });

    const initStickyHeader = (header) => {
      const stickyMode = header.getAttribute('sticky');
      if (!stickyMode) return;

      let offscreen = false;
      let lastScrollTop = 0;
      let scrollRafId = null;
      let intersectionObserver = null;
      let scrollTarget = null;

      const setStickyState = (state) => {
        header.dataset.stickyState = state;
      };

      const observeStickyPosition = () => {
        if (intersectionObserver) {
          intersectionObserver.disconnect();
          intersectionObserver = null;
        }

        intersectionObserver = new IntersectionObserver(
          ([entry]) => {
            if (!entry) return;
            if (stickyMode === 'always') {
              setStickyState(entry.isIntersecting ? 'inactive' : 'active');
            } else {
              offscreen = !entry.isIntersecting || header.dataset.stickyState === 'active';
            }
          },
          {
            threshold: stickyMode === 'always' ? 1 : 0,
            root: getIntersectionRoot(),
          }
        );

        intersectionObserver.observe(header);
      };

      const updateScrollState = () => {
        if (!offscreen && stickyMode !== 'always') return;

        const scrollTop = getScrollTop();
        const headerTop = header.getBoundingClientRect().top;
        const isScrollingUp = scrollTop < lastScrollTop;
        const isAtTop = headerTop >= 0;

        if (stickyMode === 'always') {
          lastScrollTop = scrollTop;
          return;
        }

        if (isScrollingUp) {
          if (isAtTop) {
            offscreen = false;
            setStickyState('inactive');
          } else {
            setStickyState('active');
          }
        } else if (header.dataset.stickyState === 'active') {
          setStickyState('idle');
        } else {
          setStickyState('idle');
        }

        lastScrollTop = scrollTop;
      };

      const handleScroll = () => {
        if (scrollRafId !== null) return;
        scrollRafId = requestAnimationFrame(() => {
          scrollRafId = null;
          updateScrollState();
        });
      };

      const bindScroll = () => {
        if (scrollTarget) {
          scrollTarget.removeEventListener('scroll', handleScroll);
        }
        scrollTarget = getScrollEventTarget();
        scrollTarget.addEventListener('scroll', handleScroll, { passive: true });
        observeStickyPosition();
      };

      bindScroll();
      squeezeQuery.addEventListener('change', bindScroll);
      setStickyState('inactive');
    };

    document.querySelectorAll(`${rootSelector}[sticky]`).forEach(initStickyHeader);

    /* Horizon theme.liquid only measures header-component; set the same vars for Azz header */
    const setHeaderHeightVars = () => {
      const header = document.querySelector(rootSelector);
      const headerGroup = document.querySelector('#header-group');
      if (!header || !headerGroup) return;

      const headerHeight = header.offsetHeight;
      let headerGroupHeight = 0;
      for (const element of headerGroup.children) {
        if (!(element instanceof HTMLElement)) continue;
        if (element.contains(header)) continue;
        headerGroupHeight += element.offsetHeight;
      }

      document.body.style.setProperty('--header-height', `${headerHeight}px`);
      document.body.style.setProperty('--header-group-height', `${headerGroupHeight}px`);
    };

    setHeaderHeightVars();
    window.addEventListener('resize', setHeaderHeightVars);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["azz-mega-menu"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const MENU_SELECTOR = '.azz-mega-menu';
    const DETAILS_SELECTOR = 'details.azz-mega-nav-item__details';
    const OPEN_ATTR = 'data-open';
    const designMode = Boolean(window.Shopify && window.Shopify.designMode);
    const mobileQuery = window.matchMedia('(max-width: 989px)');

    const getMenus = () => document.querySelectorAll(MENU_SELECTOR);

    const syncToggleButtons = (open) => {
      document.querySelectorAll('[data-azz-mega-drawer-open]').forEach((btn) => {
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    };

    const openShopPanel = (menu) => {
      const items = [...menu.querySelectorAll(DETAILS_SELECTOR)];
      const shop =
        items.find((details) => {
          const label = details.querySelector('.azz-mega-nav-item__label');
          return label && label.textContent.trim().toLowerCase() === 'shop';
        }) || items[0];
      if (!shop) return;
      closeOpenDetails(shop);
      shop.open = true;
    };

    const focusDrawerSearch = (menu) => {
      const input = menu.querySelector('.azz-mega-menu__drawer-search-input');
      if (!input) return;
      requestAnimationFrame(() => {
        input.focus({ preventScroll: true });
        try {
          input.select();
        } catch (_) {
          /* ignore */
        }
      });
    };

    const setDrawerOpen = (menu, open, options = {}) => {
      if (!menu) return;
      if (open) {
        menu.setAttribute(OPEN_ATTR, '');
        document.documentElement.classList.add('azz-mega-drawer-open');
        if (options.openShop) openShopPanel(menu);
        if (options.focusSearch) focusDrawerSearch(menu);
      } else {
        menu.removeAttribute(OPEN_ATTR);
        document.documentElement.classList.remove('azz-mega-drawer-open');
        menu.querySelectorAll(`${DETAILS_SELECTOR}[open]`).forEach((d) => {
          d.open = false;
        });
      }
      syncToggleButtons(open);
    };

    const closeAllDrawers = () => {
      getMenus().forEach((menu) => setDrawerOpen(menu, false));
    };

    const closeOpenDetails = (except) => {
      getMenus().forEach((menu) => {
        menu.querySelectorAll(`${DETAILS_SELECTOR}[open]`).forEach((details) => {
          if (details !== except) details.open = false;
        });
      });
    };

    /* Theme editor: keep details open when "Keep panel open for editing" is on */
    if (designMode) {
      const forceOpenEditingPanels = () => {
        getMenus().forEach((menu) => {
          menu.querySelectorAll(`${DETAILS_SELECTOR}[data-azz-mega-force-open]`).forEach((details) => {
            details.open = true;
          });
        });
      };

      document.addEventListener('shopify:section:load', () => {
        requestAnimationFrame(forceOpenEditingPanels);
        setTimeout(forceOpenEditingPanels, 50);
      });

      document.addEventListener(
        'click',
        (event) => {
          const summary =
            event.target instanceof Element
              ? event.target.closest('summary.azz-mega-nav-item__trigger')
              : null;
          if (!summary) return;
          const details = summary.closest(`${DETAILS_SELECTOR}[data-azz-mega-force-open]`);
          if (!details) return;
          event.preventDefault();
          details.open = true;
        },
        true
      );

      forceOpenEditingPanels();
    }

    /* Burger / search icon / close / backdrop */
    document.addEventListener('click', (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      const openBtn = target.closest('[data-azz-mega-drawer-open]');
      if (openBtn) {
        const menu = document.querySelector(MENU_SELECTOR);
        if (!menu) return;
        const mode = openBtn.getAttribute('data-azz-mega-drawer-open') || '';
        const viaSearch = mode === 'search';
        const isOpen = menu.hasAttribute(OPEN_ATTR);

        if (viaSearch) {
          /* Always open (or keep open) with Shop + search focus */
          setDrawerOpen(menu, true, { openShop: true, focusSearch: true });
        } else {
          setDrawerOpen(menu, !isOpen);
        }
        return;
      }

      if (target.closest('[data-azz-mega-drawer-close]')) {
        closeAllDrawers();
      }
    });

    /* Only one mega panel open at a time (desktop + mobile accordion) */
    document.addEventListener(
      'toggle',
      (event) => {
        const details = event.target;
        if (!(details instanceof HTMLDetailsElement) || !details.open) return;
        if (!details.matches(DETAILS_SELECTOR)) return;
        if (!details.closest(MENU_SELECTOR)) return;
        closeOpenDetails(details);
      },
      true
    );

    /* Desktop: click outside open panel closes it */
    document.addEventListener(
      'pointerdown',
      (event) => {
        if (!(event.target instanceof Element)) return;
        if (mobileQuery.matches) return;

        getMenus().forEach((menu) => {
          menu.querySelectorAll(`${DETAILS_SELECTOR}[open]`).forEach((details) => {
            if (!details.contains(event.target)) details.open = false;
          });
        });
      },
      true
    );

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const anyDrawer = [...getMenus()].some((m) => m.hasAttribute(OPEN_ATTR));
      if (anyDrawer) {
        closeAllDrawers();
        return;
      }
      closeOpenDetails();
    });

    mobileQuery.addEventListener('change', () => {
      if (!mobileQuery.matches) closeAllDrawers();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
